import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { SELLER_DETAILS_PAGE_NAME } from '@/components/pages/cabinet/routes'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerCard',
  props: {
  seller: Object,
  statuses: Object,
  colors: Object,
  statusType: String,
  detailsPageLink: {
    type: String,
    default: '',
  },
  updatePageLink: {
    type: String,
    default: '',
  },
},
  emits: ['select'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { $t } = useGlobal()
const emit = __emit
const props = __props
const { id, firstName, lastName, dateJoined, outlet, phone } = props.seller
const val = ref(false)

function setValue(val) {
  emit("select", props.seller.id)
}


const __returned__ = { $t, emit, props, id, firstName, lastName, dateJoined, outlet, phone, val, setValue, ref, get useGlobal() { return useGlobal }, get SELLER_DETAILS_PAGE_NAME() { return SELLER_DETAILS_PAGE_NAME } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})